import {Component} from 'react'
import {BsSearch} from 'react-icons/bs'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import Header from '../Header'
import JobItem from '../JobItem'
import './index.css'

class Jobs extends Component {
  state = {
    profileData: {},
    jobData: [],
    empType: '',
    salary: '',
    searchInput: '',
    isProfileApiSuccess: true,
    isJobsApiSuccess: true,
  }

  componentDidMount() {
    this.getProfile()
    this.getJobs()
  }

  getProfile = async () => {
    const jwtToken = Cookies.get('jwt_token')
    const url = 'https://apis.ccbp.in/profile'

    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }

    const response = await fetch(url, options)

    if (response.ok) {
      const data = await response.json()
      const profile = {
        imageUrl: data.profile_details.profile_image_url,
        name: data.profile_details.name,
        bio: data.profile_details.short_bio,
      }
      this.setState({profileData: profile, isProfileApiSuccess: true})
    } else {
      this.setState({isProfileApiSuccess: false})
    }
  }

  getJobs = async () => {
    const {empType, salary, searchInput} = this.state
    const jwtToken = Cookies.get('jwt_token')

    const url = `https://apis.ccbp.in/jobs?employment_type=${empType}&minimum_package=${salary}&search=${searchInput}`

    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }

    const response = await fetch(url, options)

    if (response.ok) {
      const data = await response.json()

      const jobs = data.jobs.map(each => ({
        id: each.id,
        title: each.title,
        rating: each.rating,
        location: each.location,
        employmentType: each.employment_type,
        packages: each.package_per_annum,
        companyLogoUrl: each.company_logo_url,
        jobDescription: each.job_description,
      }))

      this.setState({jobData: jobs, isJobsApiSuccess: true})
    } else {
      this.setState({isJobsApiSuccess: false})
    }
  }

  onChangeEmploymentType = event => {
    this.setState({empType: event.target.value}, this.getJobs)
  }

  onChangeSalaryRange = event => {
    this.setState({salary: event.target.value}, this.getJobs)
  }

  onChangeSearch = event => {
    this.setState({searchInput: event.target.value})
  }

  onClickSearch = () => {
    this.getJobs()
  }

  renderProfileSuccess = () => {
    const {profileData} = this.state

    return (
      <div className="profile-card">
        <img src={profileData.imageUrl} alt="profile" className="profile-pic" />
        <h1 className="profile-name">{profileData.name}</h1>
        <p className="profile-bio">{profileData.bio}</p>
      </div>
    )
  }

  renderProfileFailure = () => (
    <div className="profile-fail">
      <button className="retry-btn" onClick={() => this.getProfile()}>
        Retry
      </button>
    </div>
  )

  renderJobsSuccess = () => {
    const {jobData} = this.state
    return (
      <ul className="jobs-list">
        {jobData.map(job => (
          <JobItem key={job.id} jobData={job} />
        ))}
      </ul>
    )
  }

  renderNoJobs = () => (
    <div className="no-jobs-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
        alt="no jobs"
        className="no-jobs-img"
      />
      <h1>No Jobs Found</h1>
      <p>We could not find any jobs. Try other filters.</p>
    </div>
  )

  renderJobsFailure = () => (
    <div className="jobs-failure">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure view"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>We cannot seem to find the page you are looking for</p>
      <button className="retry-btn" onClick={this.getJobs}>
        Retry
      </button>
    </div>
  )

  renderJobsView = () => {
    const {isJobsApiSuccess, jobData} = this.state

    if (!isJobsApiSuccess) {
      return this.renderJobsFailure()
    }

    if (jobData.length === 0) {
      return this.renderNoJobs()
    }

    return this.renderJobsSuccess()
  }

  render() {
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken === undefined) return <Redirect to="/login" />

    const {employmentTypesList, salaryRangesList} = this.props
    const {jobData, isJobsApiSuccess, isProfileApiSuccess} = this.state

    return (
      <>
        <Header />

        <div className="jobs-bg">
          <div className="filters-left">
            {isProfileApiSuccess
              ? this.renderProfileSuccess()
              : this.renderProfileFailure()}
            <hr className="divider" />

            <h4 className="filter-heading">Type of Employment</h4>
            <ul className="filter-list">
              {employmentTypesList.map(each => (
                <li key={each.employmentTypeId}>
                  <input
                    type="checkbox"
                    id={each.employmentTypeId}
                    value={each.employmentTypeId}
                    onChange={this.onChangeEmploymentType}
                  />
                  <label htmlFor={each.employmentTypeId}>{each.label}</label>
                </li>
              ))}
            </ul>
            <hr className="divider" />

            <h4 className="filter-heading">Salary Range</h4>
            <ul className="filter-list">
              {salaryRangesList.map(each => (
                <li key={each.salaryRangeId}>
                  <input
                    type="radio"
                    id={each.salaryRangeId}
                    name="salary"
                    value={each.salaryRangeId}
                    onChange={this.onChangeSalaryRange}
                  />
                  <label htmlFor={each.salaryRangeId}>{each.label}</label>
                </li>
              ))}
            </ul>
          </div>

          <div className="jobs-right">
            <div className="search-bar">
              <input
                type="search"
                className="search-input"
                placeholder="Search"
                onChange={this.onChangeSearch}
              />
              <button
                className="search-btn"
                data-testid="searchButton"
                onClick={this.onClickSearch}
              >
                <BsSearch className="search-icon" />
              </button>
            </div>
            <div>{this.renderJobsView()}</div>
          </div>
        </div>
      </>
    )
  }
}

export default Jobs
